<template>
  <v-container
    class="login-page d-flex justify-content-center item-align-center"
    fill-height
    fluid
  >
    <v-card elevation="7" width="400px">
      <v-app-bar class="text-white pa-1" color="primary">
        <v-toolbar-title class="mx-auto"
          ><strong> <h1>S.T.A.R.S.</h1></strong></v-toolbar-title
        >
      </v-app-bar>
      <v-card-text>
        <v-form ref="login" v-model="valid" lazy-validation>
          <v-text-field
            v-model="email"
            outlined
            placeholder="E-posta"
            prepend-icon="mdi-account"
            required
            type="email"
            @keypress.enter="onSubmit"
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="password?.length > 0 ? 'mdi-eye' : ''"
            :type="eye ? 'text' : 'password'"
            outlined
            placeholder="Parola"
            prepend-icon="mdi-lock"
            required
            @keypress.enter="onSubmit"
            @click:append="eye = !eye"
          ></v-text-field>
          <v-card-actions class="d-flex justify-content-end mt-2">
            <router-link :to="{ name: 'forgot-password' }">
              <v-btn class="text-dark mr-2" color="secondary"
                >Parolamı Unuttum</v-btn
              >
            </router-link>
            <v-btn
              :disabled="!valid"
              :loading="loading"
              color="primary"
              @click="onSubmit"
              @keypress.enter="onSubmit"
              >Giriş Yap</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { DELETE_STATE, LOGIN } from "@/core/services/store/auth.module";

export default {
  name: "SM-Login",
  data() {
    return {
      email: null,
      password: null,
      eye: false,
      valid: true,
      loader: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions([LOGIN, DELETE_STATE, "redirectAfterLogin"]),
    resetForm() {
      this.email = null;
      this.password = null;
    },
    async onSubmit() {
      this.loader = "loading";
      const valid = this.$refs.login.validate();
      if (!valid) {
        return;
      }
      await this.deleteState();
      try {
        await this.login({ email: this.email, password: this.password });
        window.localStorage.setItem("loginType", "public");
        this.redirectAfterLogin();
      } catch {
        await this.deleteState();
        this.$toast.error("E-Posta ve ya parola alanı hatalı.", {
          position: "bottom-right",
          duration: 2000,
        });
      }
      this[this.loader] = false;
      this.loader = null;
    },
  },
  watch: {
    password() {
      if (this.eye) {
        this.eye = false;
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];
    },
  },
};
</script>
